import { type HttpClient, query } from '../http';

import { type AuditPage, type ListAuditQuery } from './audit.types';

/**
 * Reading what administrators decided.
 *
 * Warning: an administration route. An application session is refused here, and
 * that is the separation working rather than a gap.
 */
export function createAuditApi(http: HttpClient) {
  return {
    /**
     * One page of the log, newest first.
     *
     * ⚠️ Cursor paging, never an offset. The log grows while somebody reads it,
     * and an offset would show them the same row twice or skip one between two
     * pages — on the one table where « I saw everything » has to be true.
     *
     * @param criteria How much to read, from where, and about what.
     * @returns The page, and the cursor for the next.
     */
    list: (criteria: ListAuditQuery = {}) =>
      http.get<AuditPage>(
        `/admin/audit${query({
          cursor: criteria.cursor,
          limit: criteria.limit,
          targetType: criteria.targetType,
          targetId: criteria.targetId,
        })}`,
      ),
  };
}
